import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'cream-dark' | 'white';
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-[#FAF7F2]',
    'cream-dark': 'bg-[#F5F0EB]',
    white: 'bg-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-6 ${bgColors[background]} ${className}`} data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">{children}</div>
    </section>;
}
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-128">
      {children}
    </motion.div>;
}